import { render, staticRenderFns } from "./accessDenied.vue?vue&type=template&id=dddd01ae"
import script from "./accessDenied.vue?vue&type=script&lang=js"
export * from "./accessDenied.vue?vue&type=script&lang=js"
import style0 from "./accessDenied.vue?vue&type=style&index=0&id=dddd01ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports